// @ts-check
import Vue from 'vue';

/**
 * @type {() => import('@/classes/agreement').Clause}
 */
const ClauseObjectType = Object;

/**
 * @typedef {import('@/classes/clauseRenderNode').ClauseNodeValues} ClauseNodeValues
 */
/**
 * @type {() => ClauseNodeValues}
 */
const ValueArrayType = Array;

export default Vue.extend({
  props: {
    clause: {
      type: ClauseObjectType,
      required: true,
    },

    value: {
      type: ValueArrayType,
      required: true,
    },
  },

  render(h) {
    /**
     * @type {ReturnType<typeof ClauseObjectType>}
     */
    const clause = this.clause;

    const children = clause.layoutWeb.map(node => node.render(h, this.renderContext));

    return h('div', children);
  },

  computed: {
    /**
     * @return {import('@/classes/clauseRenderNode').ClauseNodeRenderContext}
     */
    renderContext() {
    /**
     * @type {ClauseNodeValues}
     */
      const value = this.value;

      return {
        props: {
          value,
        },
        on: {
          input: this.onInputHandler,
        },
      };
    },
  },

  methods: {
    /**
     *
     * @param {ClauseNodeValues} data
     */
    onInputHandler(data) {
      this.$emit('input', data);
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppAdditionalAgreements/ClauseRenderer.js